import { VStack } from "@chakra-ui/react";
import { Header } from "../components/common";
import { ReviewForm } from "../components/forms";
import { KamkomBankLogo } from "../components/svg";
// import { BlockedVPNScreen } from "./BlockedVPNScreen";
// import { useEffect, useState } from "react";
// import { getUserGeoData } from "./BlockedVPNScreen.api";


// const DEFAULT_USER_LOCATION = "Russia";

export const FormScreen = () => {
  // const [userLocation, setUserLocation] = useState(DEFAULT_USER_LOCATION);

  // useEffect(() => {
  //   getUserGeoData().then((data) => data && setUserLocation(data?.country_name));
  // }, []);

  // const isDefaultLocation = userLocation === DEFAULT_USER_LOCATION;


  // if (!isDefaultLocation) {
  //   return <BlockedVPNScreen />;
  // }

  return (
    <VStack padding="16px 16px 0" gap="16px" bg="background.gray" minH="100vh">
      <Header logo={<KamkomBankLogo />} phone="+7(800) 200-86-38" />
      <ReviewForm />
    </VStack>
  );
};
